import script from "./CountryData.vue?vue&type=script&setup=true&lang=js"
export * from "./CountryData.vue?vue&type=script&setup=true&lang=js"

import "./CountryData.vue?vue&type=style&index=0&id=7a293b4a&lang=scss"

const __exports__ = script;

export default __exports__